import type { Block } from '@gitbook/slate';

import type { ParsingOptions } from './options';

export interface ParsingContext extends ParsingOptions {
    /**
     * Allocate the nodes for a footnote.
     */
    setDefinitionForFootnoteId: (id: string, definition: () => Promise<Block[]>) => void;

    /**
     * Get the fragment for a footnote ID.
     */
    getDefinitionForFootnoteId: (ridef: string) => Promise<Block[]>;
}

/**
 * Create the local context for parsing.
 */
export function createParsingContext(options: ParsingOptions): ParsingContext {
    const footnoteDefinitions = new Map<string, () => Promise<Block[]>>();

    return {
        ...options,
        setDefinitionForFootnoteId: (ref, definition) => {
            footnoteDefinitions.set(ref, definition);
        },
        getDefinitionForFootnoteId: async (id) => {
            return footnoteDefinitions.get(id)?.() || [];
        },
    };
}
